import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { fetchUserByJWT } from './store/slices/authSlice';
import store from './store/store';
import App from './components/App';
import './style.scss';
import { setAuthData } from './store/slices/authSlice';
import { getUserId, isUserLoggedIn, getJwtToken, isAdmin } from './utils/api';

// Find all containers with octopus-react-container class
document.addEventListener('DOMContentLoaded', function() {
    const containers = document.querySelectorAll('.octopus-react-container');
    
    // Initialize auth data in Redux store
    const userId = getUserId();
    const jwtToken = getJwtToken();
    const isLoggedIn = isUserLoggedIn();
    
    if (userId && jwtToken) {
        store.dispatch(setAuthData({
            userId,
            jwtToken,
            isLoggedIn,
        }));
    }
    if(jwtToken){
        store.dispatch(fetchUserByJWT(jwtToken));
    }
    
    containers.forEach(container => {
        const componentName = container.getAttribute('data-component') || 'default';
        const page = container.getAttribute('data-page') || '';
        const dataProps = container.getAttribute('data-props');

        
        let props = {};
        if (dataProps) {
            try {
                props = JSON.parse(dataProps);
            } catch (e) {
                console.error('Error parsing data-props:', e);
            }
        }
        
        // Include page from data attribute if not already in props
        if (page && !props.page) {
            props.page = page;
        }

        props.isAdmin = isAdmin();
        props.userId = userId;
        // Render React component with Redux Provider
        const root = createRoot(container);
        root.render(
            <Provider store={store}>
                <App componentName={componentName} page={page} {...props} />
            </Provider>
        );
    });
});

